export const state = {
	documents: {
		myOperations: [],
		personalEstate: [],
		justificatifs: [],
		autre: {
			shared: [],
			private: []
		}
	}
}



// WEBPACK FOOTER //
// ./src/common/store/Documents/state.js